var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Card",
    { staticClass: "settings-mandate" },
    [
      _c(
        "div",
        { staticClass: "settings-mandate__header" },
        [
          _c(
            "h2",
            { staticClass: "typographies-heading-h2 settings-mandate__title" },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t.__("settings.mandate.title")) +
                  "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c("CompassLink", {
            attrs: {
              label: _vm.$t.__("common.actions.view_faq"),
              link:
                "https://help.sellsy.com/fr/collections/14117844-facturation-electronique",
              target: "_blank",
              prefixIcon: "help-circle-fill"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass:
            "typographies-paragraph-medium-regular settings-mandate__description"
        },
        [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t.__("settings.mandate.description")) +
              "\n    "
          )
        ]
      ),
      _vm._v(" "),
      _vm.isLoading
        ? _c(
            "div",
            { staticClass: "settings-mandate__loading-state" },
            [
              _c("CompassLoader", { attrs: { size: "large" } }),
              _vm._v(" "),
              _c(
                "p",
                { staticClass: "typographies-paragraph-medium-regular" },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t.__("settings.mandate.loading_message")) +
                      "\n        "
                  )
                ]
              )
            ],
            1
          )
        : [
            !_vm.mandates.length
              ? _c(
                  "CompassEmptyState",
                  {
                    attrs: {
                      title: _vm.$t.__("settings.mandate.empty_state.title"),
                      illustrationPath:
                        "/ressources/logged/img/illustrations/pdp/document-signature.svg"
                    }
                  },
                  [
                    _c("CompassButton", {
                      attrs: {
                        label: _vm.$t.__("settings.mandate.empty_state.button")
                      },
                      on: { click: _vm.handleCompleteMandate }
                    })
                  ],
                  1
                )
              : [
                  _c(
                    "h3",
                    {
                      staticClass:
                        "typographies-heading-h3 settings-mandate__sub-title"
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t.__("settings.mandate.list.title")) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "settings-mandate__list" },
                    _vm._l(_vm.mandates, function(mandate) {
                      return _c("MandateItem", {
                        key: mandate.id,
                        attrs: { mandate: mandate },
                        on: { mandateDeleted: _vm.getMandates }
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "settings-mandate__footer" },
                    [
                      _c(
                        "p",
                        {
                          staticClass: "typographies-paragraph-medium-regular"
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$t.__("settings.mandate.siren_change")
                              ) +
                              "\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("CompassButton", {
                        attrs: {
                          label: _vm.$t.__("settings.mandate.new_mandate"),
                          type: "secondary",
                          disabled: _vm.isDisabled
                        },
                        on: { click: _vm.createNewMandate }
                      })
                    ],
                    1
                  )
                ]
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }